import '../styles/About.css';
import Logo from './Logo';

import ashleyImage from '../assets/members/ashley.webp';
import chrisImage from '../assets/members/chris.webp';
import jeffImage from '../assets/members/jeff.webp';
import mitchImage from '../assets/members/mitch.webp';

export default function About() {
  const bandMembers = [
    {
      name: 'Ashley',
      image: ashleyImage,
      bio: 'Vocals'
    },
    {
      name: 'Chris',
      image: chrisImage,
      bio: 'Electric Guitar, Vocals'
    },
    {
      name: 'Jeff',
      image: jeffImage,
      bio: 'Vocals, Acoustic Guitar'
    },
    {
      name: 'Mitch',
      image: mitchImage,
      bio: 'Vocals, Acoustic Guitar'
    }
  ];

  return (
    <div className="about">
      <Logo />
      <h1>About Us</h1>
      <p>Feeling Minnesota is an acoustic band made up of seasoned musicians who simply love playing live music. Blending country, rock, and pop favorites with a fresh acoustic twist, we perform the songs you love, delivering the kind of setlist that feels like your favorite playlist coming to life.</p>
      <p>With stripped down arrangements, rich three part harmonies, and a laidback, authentic vibe, we bring new energy to familiar hits. The result is a nostalgic yet modern sound that connects with any crowd.</p>
      <p>We’re always expanding our song list and are happy to take requests to make your event truly personal. Whether it’s a backyard party, a brewery night, or a special celebration, we’d love to be part of your next gathering.</p>
      <h2>Meet the Band</h2>
      <div className="band-members">
        {bandMembers.map((member, index) => (
          <div key={index} className="member">
            <img src={member.image} alt={member.name} loading="lazy" decoding="async" width="200" height="200" />
            <h3>{member.name}</h3>
            <p>{member.bio}</p>
          </div>
        ))}
      </div>
    </div>
  );
}